// Vendor Libs
import React, {useState} from 'react';
import {Button} from 'primereact/button';
import PropTypes from 'prop-types';

// Styles
import './legend.scss';

export const mappingColors = [
    {type: 'isShell', data: {color: '#dbffc3', text: 'Both Rovi ID and Tms ID present'}},
    {type: 'justTms', data: {color: '#aed6f1  ', text: 'Tms ID present, Rovi and source IDs absent'}},
    {type: 'justRovi', data: {color: '#e6d8fd', text: 'Rovi ID present, source and Tms IDs absent'}},
    {type: 'justSource', data: {color: '#b3ffb3', text: 'Source ID present, Rovi and Tms IDs absent'}},
    {type: 'noRoviNoTmsNoSourceId', data: {color: '#fdcece', text: 'Rovi ID, Tms ID and sourceID absent'}},
    {type: 'roviOrTmsOrSource', data: {color: '#fdf3de', text: 'Tms ID, or Rovi or source IDs present'}},
];

export const getRowsColorLogic = (dataRow, toMap, className) => {
    if (!toMap) {
        return {isMapping: false};
    }
    const isShell =
        dataRow?.roviProgramId !== null &&
        dataRow?.roviProgramId !== 0 &&
        dataRow?.tmsId !== null &&
        dataRow?.tmsId?.length;

    const justRovi =
        dataRow?.roviProgramId !== null &&
        dataRow?.roviProgramId !== 0 &&
        (dataRow?.tmsId === null || !dataRow?.tmsId?.length) &&
        (dataRow?.sourceId === null || !dataRow?.sourceId?.length);

    const justTms =
        (dataRow?.roviProgramId === null || dataRow?.roviProgramId === 0) &&
        (dataRow?.sourceId === null || !dataRow?.sourceId?.length) &&
        dataRow?.tmsId !== null &&
        dataRow?.tmsId?.length;

    const noRoviNoTmsNoSourceId =
        (!dataRow?.roviProgramId && !dataRow?.tmsId && !dataRow?.sourceId) ||
        (dataRow?.roviProgramId === 0 && !dataRow?.tmsId?.length && !dataRow?.sourceId?.length) ||
        (dataRow?.roviProgramId === null && !dataRow?.tmsId?.length && !dataRow?.sourceId?.length);

    const justSource =
        (dataRow?.roviProgramId === null || dataRow?.roviProgramId === 0) &&
        (dataRow?.tmsId === null || !dataRow?.tmsId?.length) &&
        dataRow?.sourceId !== null &&
        dataRow?.sourceId?.length;

    const roviOrTmsOrSource =
        (dataRow?.roviProgramId !== null && dataRow?.roviProgramId !== 0) ||
        (dataRow?.sourceId !== null && dataRow?.sourceId?.length) ||
        (dataRow?.tmsId !== null && dataRow?.tmsId?.length);

    let rowOptions = {color: 'white', text: ''};

    if (isShell !== false) {
        rowOptions = mappingColors.find((m) => m.type === 'isShell')?.data;
    } else if (justRovi !== false) {
        rowOptions = mappingColors.find((m) => m.type === 'justRovi')?.data;
    } else if (justTms !== false) {
        rowOptions = mappingColors.find((m) => m.type === 'justTms')?.data;
    } else if (noRoviNoTmsNoSourceId !== false) {
        rowOptions = mappingColors.find((m) => m.type === 'noRoviNoTmsNoSourceId')?.data;
    } else if (justSource !== false) {
        rowOptions = mappingColors.find((m) => m.type === 'justSource')?.data;
    } else if (roviOrTmsOrSource !== false) {
        rowOptions = mappingColors.find((m) => m.type === 'roviOrTmsOrSource')?.data;
    }

    if (className?.includes('selected')) {
        return {
            isMapping: true,
            rowOptions: {color: '#3691cc', text: rowOptions.text},
        };
    }

    return {
        isMapping: isShell || justRovi || justTms || noRoviNoTmsNoSourceId || justSource || roviOrTmsOrSource,
        rowOptions,
    };
};

export function DrawLegend({data}) {
    const [show, setShow] = useState(false);

    const renderItem = (item, index) => (
        <div className="colorsDiv" key={index}>
            <div
                className="colorsBox"
                style={{
                    backgroundColor: item.color,
                }}
            />
            {item.text}
        </div>
    );

    return (
        <div>
            <Button
                className="colorsPopupButton"
                id="colorsPopupButton"
                onMouseOut={() => setShow(false)}
                onMouseOver={() => setShow(true)}
            >
                Colors Legend
            </Button>

            {show && (
                <div className="colorsPopup">
                    {data.map((d) => d.data).map((item, index) => renderItem(item, index))}
                </div>
            )}
        </div>
    );
}

export function ColoredRow({children, rowOptions}) {
    return (
        <div style={{backgroundColor: rowOptions.color}} title={rowOptions.text}>
            {children}
        </div>
    );
}

DrawLegend.propTypes = {
    data: PropTypes.array,
};

ColoredRow.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    rowOptions: PropTypes.object,
};
